/**
 * Visual grouping: repeated guide headers across consecutive rows with the same guide_id.
 */
export function applyGuideGrouping(rows) {
	if (!rows?.length) return [];
	const result = [];
	let lastGuideId = null;
	rows.forEach((item, index) => {
		const isNewGroup = item.guide_id !== lastGuideId;
		result.push({
			...item,
			_isFirstInGroup: isNewGroup,
			_groupIndex: index,
		});
		lastGuideId = item.guide_id;
	});
	return result;
}
